<template lang="pug">
  v-content
    v-container.grey.lighten-4
      v-row
        v-col
          pageTitle 伝票詳細
    v-container.indigo.lighten-5
      v-card
        v-card-text
          v-row
            v-col
              span.font-italic 伝票番号:
              span.pl-4.text--primary {{ sales_slip.slip_no }}
              span.pl-8.font-italic 伝票日付:
              span.pl-4.text--primary {{ sales_slip.slip_date }}
            v-spacer
            v-col
              printDialog(ref="prDialog" v-bind:sales_slip="sales_slip")
              v-btn(@click="openPrDialog" width=100 outlined color="primary") 印刷
          v-row
            v-col
              v-card(outlined)
                v-card-text
                  span.font-italic お得意先:
                  span.pl-4 {{ sales_slip.customer.kana}}
                  br
                  span.text--primary.pl-8 {{ sales_slip.customer.name }}
                  br
                  span.font-italic.pl-4 伝票上の表示:
                  pre.pl-8.text--primary
                    | {{ sales_slip.customer_label }} {{ sales_slip.keisyo }}
            v-col
              v-card(outlined)
                v-card-text
                  span.font-italic 見積書日付:
                  span.pl-4.text--primary {{ sales_slip.estimate_date}}
                  br
                  span.font-italic 納期：
                  span.pl-4.text--primary {{ sales_slip.delivery_date}}
                  span.pl-8.font-italic 納入場所：
                  span.pl-4.text--primary {{ sales_slip.delivery_point}}
                  br
                  span.font-italic 取引条件：
                  span.pl-4.text--primary {{ sales_slip.term_of_sale}}
                  span.pl-8.font-italic 有効期限：
                  span.pl-4.text--primary {{ sales_slip.validity_period}}
          v-row
            v-col
              span.font-italic 振込先：
              span.pl-4.text--primary {{ bank_account }}
              span.pl-8.font-italic 消費税率：
              span.pl-4.text--primary {{ pstr(sales_slip.tax_rate) }}
              span.pl-8.font-italic 軽減税率：
              span.pl-4.text--primary(v-if="sales_slip.reduced_tax_rate > 0") {{ pstr(sales_slip.reduced_tax_rate) }}
              span.pl-4.text--primary(v-if="!(sales_slip.reduced_tax_rate > 0)") -
              br
              span.pl-8 合計
              span.font-italic.pl-4 税抜き
              span.pl-4.text--primary {{ nc(sales_slip.total_base_price) }}
              span.font-italic.pl-8 消費税
              span.pl-4.text--primary {{ nc(sales_slip.total_tax) }}
              span.font-italic.pl-8 総額
              span.pl-4.text--primary {{ nc(sales_slip.total_amount) }}
          v-row
            v-col
              v-data-table(:headers="item_headers" item-key="id"
                :items="sales_slip.sales_slip_items"
                :items-per-page="100"
                :hide-default-footer="true" dense
              )
                template(v-slot:item.quantity="{item}") {{ nc(item.quantity) }}
                template(v-slot:item.unit_price="{item}") {{ nc(item.unit_price) }}
                template(v-slot:item.amount="{item}") {{ nc(item.amount) }}
          v-row
            v-col
              v-card(outlined)
                v-card-subtitle.font-italic 備考:
                v-card-text
                  pre.text--primary {{ sales_slip.note }}
        v-card-actions
          v-spacer
          v-btn(color="primary" width="100"
            @click="$router.push('/sales_slip/edit/' + sales_slip.id)"
          ) 編集
          v-spacer
          v-btn(@click="$router.push('/sales_slip/list')") 一覧に戻る
          v-spacer
</template>

<script>
  // import debugLog from '@/utils/debugLog'
  import { getSalesSlip } from '@/api/sales_slip'
  import pageTitle from '@/components/pageTitle'
  import { bank_account2str, percent_str } from '@/utils/helpers'
  import printDialog from './printDialog'
  // import ToolTipIcon from '@/components/ToolTipIcon'

  export default {
    name: 'SalesSlipShow',
    components: {pageTitle, printDialog},
    data() { return {
      sales_slip: { customer: {} },
      item_headers: [
        {text: '品番・商品名', value: 'item_name'},
        {text: '数量', value: 'quantity', align: 'end'},
        {text: '単位', value: 'unit'},
        {text: '単価', value: 'unit_price', align: 'end'},
        {text: '金額', value: 'amount', align: 'end'},
        {text: '備考', value: 'note'}
      ]
    }},
    created() {
      const self = this
      getSalesSlip(self.$route.params.id).then((res) => {
        self.sales_slip = res.data
      })
    },
    computed: {
      bank_account() {
        return bank_account2str(this.sales_slip.bank_account)
      },
    },
    methods: {
      pstr(val) { return percent_str(val) },
      openPrDialog() {
        this.$refs.prDialog.open()
      }
    }
  }
</script>
